import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AutocompleteService} from '../autocomplete/autocomplete.service';
import {L10nModule} from '../translate';
import {SecurityAutocompleteListComponent} from './security-autocomplete-list.component';
import {SecurityAutocompleteDirective} from './security-autocomplete.directive';
import {SecurityAutocompleteService} from './security-autocomplete.service';

@NgModule({
    imports: [
        CommonModule,
        L10nModule
    ],
    declarations: [
        SecurityAutocompleteDirective,
        SecurityAutocompleteListComponent
    ],
    exports: [
        SecurityAutocompleteDirective
    ],
    providers: [
        AutocompleteService,
        SecurityAutocompleteService
    ]
})
export class SecurityAutocompleteModule {}
